import { Box, Button, Flex, FormControl, FormErrorMessage, Link, useToast } from '@chakra-ui/react';
import { OtpInput } from '@common/elements/OtpInput';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpModel } from '../../models/SignUpModel';
import { PageHeader } from './PageHeader';

type FormValues = { code: string };

export const VerifyCodeForm: React.FC = () => {
  const [codeEntered, setCodeEntered] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const { phone, setCode, resendCode } = useSignUpModel();
  const toast = useToast();

  const handleResendCode = async () => {
    const result = await resendCode();
    if (result.success)
      return toast({
        description: 'Verification code resent',
        duration: 3000,
        isClosable: true,
        position: 'top-right',

        status: 'success',
        title: 'Success!',
      });
    return toast({
      description: 'Please try again.',
      duration: 3000,
      isClosable: true,
      position: 'top-right',
      status: 'error',
      title: 'Oops, something went wrong',
    });
  };

  const PhoneNumber = () => (
    <span>
      We've sent a code to{` `}
      <strong>***-***-{phone?.slice(-4)}</strong>.{` `}
      Enter it below to verify your phone number.{' '}
      <Link fontWeight="bold" onClick={handleResendCode} fontSize={14}>
        {' '}
        Resend Code
      </Link>
    </span>
  );
  const {
    clearErrors,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<FormValues>();

  const onSubmit = handleSubmit(async () => {
    setIsLoading(true);
    const result = await setCode(codeEntered);
    if (result.error) {
      setError('code', { message: result.error });
      setCodeEntered('');
    }
    setIsLoading(false);
  });

  return (
    <Flex direction={'column'} gap={10} align="center">
      {/* Header */}
      <PageHeader title="Enter Code" subtitle={<PhoneNumber />} />

      {/* Form */}
      <Box as="form" onSubmit={onSubmit} minW={['100%', '350px']}>
        <FormControl isInvalid={Boolean(errors.code)} mb={5}>
          <OtpInput
            otp={codeEntered}
            onChange={(value) => {
              setCodeEntered(value);
              setIsComplete(value.length === 6);
              clearErrors();
            }}
          />

          <FormErrorMessage>{errors.code && errors.code.message}</FormErrorMessage>
        </FormControl>

        <Button
          isDisabled={Boolean(errors.code) || !isComplete}
          isLoading={isLoading}
          type="submit"
          w="full"
          p={7}
          maxW={'full'}>
          Continue
        </Button>
      </Box>
    </Flex>
  );
};
